import React, { Component } from 'react';
import EDIT from './../img/pencil.png'
class kurumList extends Component {
  
  render() { 
    function KurumlarList(props) {
   const sayidiz = props.sayidizisi;
   const editolay= props.editter;
    
    const listenesnesi = sayidiz.map((sayisal) =>
    <li key={sayisal.ID}>
      <div className="raportasiyici">
        <div className="adi">Adı: {sayisal.Aciklama}</div>
        <div className="adi">Kod: {sayisal.Kod}</div>
        <div className="tarih">WebUsername: {sayisal.WebUsername}</div>
        <div className="tarih">WebPassword: {sayisal.WebPassword}</div>
      </div>
      <button className="indirbuton" onClick={editolay.bind(this,sayisal)}>
          <img src={EDIT} alt="submit" />
      </button>

    </li>
    );
    return (
    <ul>{listenesnesi}</ul>
    );
    }
  
    return (
      <div className="icerik">
        <KurumlarList 
        sayidizisi={this.props.sayilar} 
       editter={this.props.editter}
        />
      </div>
    );
  }
}

export default kurumList;
